import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight, ShieldCheck, Clock, BadgeCheck, Bot } from "lucide-react";
import { getVariant, trackCtaImpression, trackCtaClick } from "@/lib/experiments";

const TRUST = [
  ["Free", ShieldCheck], ["No Spam", BadgeCheck], ["2 Minutes", Clock], ["AI Powered", Bot], ["Personalized", Sparkles],
];

// One reusable, contextual CTA. Guides every surface toward the single primary
// goal: "Get Your Free AI College Recommendation". Not a popup — inline & calm.
export default function AICtaBlock({ ctaId, headline, sub, buttonText, badges = true, variantStyle = "panel" }) {
  const navigate = useNavigate();
  const v = getVariant("primary_cta");
  const label = buttonText || v.value;

  useEffect(() => { trackCtaImpression(ctaId, v.key); }, [ctaId, v.key]);

  const go = () => { trackCtaClick(ctaId, v.key); navigate("/ai-counseling"); };

  const isSlim = variantStyle === "slim";
  return (
    <div
      data-testid={`ai-cta-${ctaId}`}
      className={`rounded-2xl border border-[#0B2A6B]/10 bg-gradient-to-br from-[#0B2A6B] to-[#123072] text-white ${isSlim ? "p-5 sm:flex sm:items-center sm:justify-between sm:gap-4" : "p-6 text-center sm:p-8"}`}
    >
      <div className={isSlim ? "" : "mx-auto max-w-xl"}>
        <h3 className={`font-display font-extrabold ${isSlim ? "text-lg" : "text-xl sm:text-2xl"}`}>{headline}</h3>
        {sub && <p className="mt-1 text-sm text-white/70">{sub}</p>}
      </div>
      <div className={isSlim ? "mt-3 shrink-0 sm:mt-0" : "mt-5"}>
        <button
          data-testid={`ai-cta-btn-${ctaId}`}
          onClick={go}
          className="inline-flex items-center gap-2 rounded-xl bg-[#D4A24C] px-6 py-3 text-sm font-bold text-white shadow-lg transition-transform hover:-translate-y-0.5 hover:bg-[#C08E3B]"
        >
          <Sparkles className="h-4 w-4" /> {label} <ArrowRight className="h-4 w-4" />
        </button>
        {badges && (
          <div className={`mt-3 flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-white/80 ${isSlim ? "" : "justify-center"}`}>
            {TRUST.map(([t, Icon]) => (
              <span key={t} className="inline-flex items-center gap-1"><Icon className="h-3 w-3 text-[#E9C877]" /> {t}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
